import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { ChartContainer } from './ChartContainer';
import { useSpendingTrendByRootCategory } from '../../hooks/useSpendingTrendByRootCategory';
import { formatMXN } from './constants';
import { formatDateRange } from '../../utils/format';

const TOOLTIP_STYLE = {
  backgroundColor: 'white',
  border: '1px solid #e5e7eb',
  borderRadius: '0.375rem',
};

const TOOLTIP_WRAPPER_STYLE = {
  zIndex: 100,
};

interface MonthlySpendingByRootCategoryChartProps {
  height?: number;
}

export function MonthlySpendingByRootCategoryChart({
  height = 350,
}: MonthlySpendingByRootCategoryChartProps) {
  const { data, rootCategories } = useSpendingTrendByRootCategory();

  if (data.length === 0 || rootCategories.length === 0) {
    return (
      <div
        className="flex items-center justify-center text-gray-500"
        style={{ height }}
      >
        No hay datos para el rango seleccionado
      </div>
    );
  }

  return (
    <ChartContainer height={height}>
      <BarChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 60 }}>
        <XAxis dataKey="month" tickFormatter={formatDateRange} />
        <YAxis tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`} />
        <Tooltip
          formatter={(value) =>
            value !== undefined ? formatMXN(Number(value)) : ''
          }
          labelFormatter={(label) =>
            typeof label === 'string' ? formatDateRange(label) : String(label)
          }
          contentStyle={TOOLTIP_STYLE}
          wrapperStyle={TOOLTIP_WRAPPER_STYLE}
          cursor={false}
        />
        <Legend
          wrapperStyle={{
            paddingTop: '16px',
            bottom: 0,
          }}
        />
        {rootCategories.map((category) => (
          <Bar
            key={category.id}
            dataKey={category.id}
            stackId="spending"
            fill={category.color}
            maxBarSize={80}
            name={category.name}
          />
        ))}
      </BarChart>
    </ChartContainer>
  );
}
